// src/utils/mapConfig.js
import { MUNICIPIOS_REGIAO } from './municipios';

// 1. Configuração imutável de estilos do mapa
// Object.freeze impede que o objeto seja alterado acidentalmente em runtime
export const MAP_STYLES = Object.freeze([
  // REGRA CRÍTICA: Oculta TODOS os nomes de cidades, bairros e localidades nativos do Google
  {
    featureType: "administrative.locality",
    elementType: "labels",
    stylers: [{ visibility: "off" }]
  },
  {
    featureType: "administrative.neighborhood",
    elementType: "labels",
    stylers: [{ visibility: "off" }]
  },
  {
    featureType: "poi",
    stylers: [{ visibility: "off" }] // Esconde POIs (lojas, hospitais, etc)
  },
  {
    featureType: "transit",
    stylers: [{ visibility: "off" }] // Esconde estações de ônibus/metrô
  },
  // Estilo visual base (Dark mode)
  {
    elementType: "geometry",
    stylers: [{ color: "#0f172a" }]
  },
  {
    elementType: "labels.text.stroke",
    stylers: [{ color: "#0f172a" }]
  },
  {
    elementType: "labels.text.fill",
    stylers: [{ color: "#64748b" }]
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [{ color: "#1e293b" }]
  },
  {
    featureType: "road",
    elementType: "geometry.stroke",
    stylers: [{ color: "#334155" }]
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [{ color: "#0f172a" }]
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [{ color: "#475569" }]
  }
]);

// 2. Configurações de restrição e zoom (Imutável)
export const MAP_SETTINGS = Object.freeze({
  center: { lat: -4.22, lng: -41.85 }, // Centro geométrico da região dos 13 municípios
  zoom: 9,
  minZoom: 8, // Permite visualizar confortavelmente toda a região mapeada com folga ao redor
  maxZoom: 20,
  mapId: 'MAPA_CULTURAL_ID',
  disableDefaultUI: true,
  zoomControl: false,
  mapTypeControl: false,
  scaleControl: true,
  streetViewControl: false,
  rotateControl: false,
  fullscreenControl: false,
  gestureHandling: "greedy", // Permite mover o mapa com 1 dedo no mobile
  restriction: {
    latLngBounds: {
      north: -3.0,  // Folga ampla ao norte acima de Piracuruca
      south: -5.5,  // Folga ampla ao sul abaixo de Pedro II e Capitão de Campos
      west: -43.5,  // Folga ampla a oeste além de Barras
      east: -40.3   // Folga ampla a leste além de Domingos Mourão
    },
    strictBounds: false // Navegação elástica e suave sem travas abruptas
  }
});

// 3. Validação de Integridade
// Esta função garante que apenas os municípios autorizados da região estão sendo usados
export const validateMunicipios = () => {
  const allowedNames = [
    'Piripiri', 'Brasileira', 'Pedro II', 'Capitão de Campos',
    'Lagoa de São Francisco', 'Domingos Mourão', 'Batalha',
    'Boa Hora', 'Barras', 'Piracuruca',
    'Milton Brandão', 'São João da Fronteira', 'São José do Divino'
  ];

  if (MUNICIPIOS_REGIAO.length !== allowedNames.length) {
    console.error(`ALERTA DE INTEGRIDADE: A lista de municípios foi alterada. Deve conter exatamente ${allowedNames.length} regiões.`);
    return false;
  }

  const hasInvalidCity = MUNICIPIOS_REGIAO.some(m => !allowedNames.includes(m.nome));
  if (hasInvalidCity) {
    console.error("ALERTA DE INTEGRIDADE: Um município não autorizado foi encontrado na configuração.");
    return false;
  }

  return true;
};
